import { render, staticRenderFns } from "./reReview.vue?vue&type=template&id=b5a735a2&scoped=true&"
import script from "./reReview.vue?vue&type=script&lang=js&"
export * from "./reReview.vue?vue&type=script&lang=js&"
import style0 from "./reReview.vue?vue&type=style&index=0&id=b5a735a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a735a2",
  null
  
)

export default component.exports